import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './OrderCard.css';
import { useS3Image } from '../../hooks/useS3Image';
import { isVideo } from '../../utils/utils';

const OrderCard = ({ order }) => {
  const LISTING_URL = process.env.REACT_APP_LISTING_SERVICE || "http://localhost:4001";
  const [copied, setCopied] = useState(false);

  let fileType = isVideo(order?.nft_details?.resource_url) ? "videos" : "images"
  const { resourceUrl, loading, error } = useS3Image(order?.nft_details?.resource_url, fileType);

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return "Unknown";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric"
    });
  };

  // Format time
  const formatTime = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit"
    });
  };

  // Truncate text
  const truncateText = (text, maxLength = 20) => {
    if (!text) return "N/A";
    return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
  };

  // Truncate hash
  const truncateHash = (hash) => {
    if (!hash) return "N/A";
    return `${hash.substring(0, 8)}...${hash.substring(hash.length - 6)}`;
  };

  // Get image URL
  const getImageUrl = () => {
    if (!order?.nft_details?.resource_url) return "/images/placeholder.png";
    return `${process.env.REACT_APP_IMAGE_URL || LISTING_URL}/images/${order.nft_details.resource_url}`;
  };

  // Get status badge color
  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'open':
        return 'status-active';
      case 'closed':
        return 'status-closed';
      case 'cancelled':
        return 'status-cancelled';
      default:
        return 'status-default';
    }
  };

  // Handle copy
  const handleCopyHash = () => {
    navigator.clipboard.writeText(order.orderHash);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="order-row">
      <div className="order-row-inner">
        {/* NFT Thumbnail */}
        {/* <Link to={`/detail/${order.nft_id}`} className="order-nft-thumb">
          <img
            src={resourceUrl}
            alt={order?.nft_details?.title || "NFT"}
            onError={(e) => {
              e.target.src = "/images/placeholder.png";
            }}
          />
        </Link> */}



        <Link to={`/detail/${order?.nft_id}`} className="order-nft-thumb">

          {isVideo(order?.nft_details?.resource_url) ? (
            <video key={resourceUrl} autoPlay loop muted playsInline>
              <source src={resourceUrl} type="video/mp4" />
            </video>
          ) : (
            <img
              src={resourceUrl}
              alt={order?.nft_details?.title || "NFT"}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = '/images/placeholder.png';
              }}
            />
          )}



        </Link>



























        {/* Order Info */}
        <div className="order-main-info">
          <div className="order-info-top">
            <div className="order-id-section">
              <span className="order-id-label">Order</span>
              <span className="order-id-value">#{order.blockchain_order_id || 'N/A'}</span>
            </div>
            <div className={`order-status ${getStatusColor(order.status)}`}>
              <span className="status-dot"></span>
              {order.status?.toUpperCase() || 'UNKNOWN'}
            </div>
          </div>

          <Link to={`/detail/${order.nft_id}`} className="order-nft-name">
            {truncateText(order?.nft_details?.title, 35)}
            <span>{order?.purchaser_details && ` (Purchased by ${order?.purchaser_details?.user_name})`}</span>
          </Link>



          <div className="order-meta-row">
            <span className="meta-item">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="6" width="18" height="15" rx="2" stroke="currentColor" strokeWidth="2" />
                <path d="M3 10H21" stroke="currentColor" strokeWidth="2" />
              </svg>
              {formatDate(order?.timestamps?.created_At)}
            </span>
            <span className="meta-divider">•</span>
            <span className="meta-item">Token #{order?.nft_details?.blockchain_token_id || 'N/A'}</span>
            {/* <span className="meta-divider">•</span>
            <span className="meta-item">User #{order.user_id || 'N/A'}</span> */}
          </div>
        </div>

        {/* Price Section */}
        <div className="order-price-section">
          <div className="order-price">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2L4 12.5L12 17L20 12.5L12 2Z" fill="currentColor" />
              <path d="M12 18L4 13.5L12 22L20 13.5L12 18Z" fill="currentColor" />
            </svg>
            {order.price || '0'} <span className="price-eth">NUC</span>
          </div>
        </div>

        {/* Hash Section */}
        <div className="order-hash-section">
          <span className="hash-label">Hash:</span>
          <span className="hash-value" title={order.orderHash}>
            {truncateHash(order.orderHash)}
          </span>
          <button
            className={`hash-copy ${copied ? 'copied' : ''}`}
            onClick={handleCopyHash}
            title={copied ? "Copied!" : "Copy"}
          >
            {copied ? '✓' : (
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="9" y="9" width="13" height="13" rx="2" stroke="currentColor" strokeWidth="2" />
                <path d="M5 15H4C2.89543 15 2 14.1046 2 13V4C2 2.89543 2.89543 2 4 2H13C14.1046 2 15 2.89543 15 4V5" stroke="currentColor" strokeWidth="2" />
              </svg>
            )}
          </button>
        </div>

        {/* Action Button */}
        <div className="order-action">
          <Link to={`/detail/${order.nft_id}`} className="btn BtnBlack btn-sm px-3 py-1">
            View NFT
          </Link>
        </div>
      </div>
    </div>
  );
};

export default OrderCard;

